const messages = {
  $navigation: {
    company_info: "公司資訊",
    company_id: "公司資訊",
    organization: "公司機構",
    mailroom: "收發室",
    sleeksign: "SleekSign",
    sleeksign_send_document: "傳送文件",
    sleeksign_document: "文件",
    company_secretary: "公司秘書",
    accounting: "會計",
    acct_packages: "計劃",
    acct_files: "檔案",
    referral: "邀請親友，賺取{amount}",
    perks: "Perks",
    billings: "收費和訂閱",
    enquiry: "查詢",
    preferences: "偏好",
    myprofile: "我的檔案",
    invitations: "新公司邀請",
    logout: "登出",
    login: "登入",
    add_new: "增加公司",
    delete_company: "刪除公司資料",
    clear_all_info: "這將清除您輸入的以下所有資料：",
    cannot_be_undone: "此操作無法撤消",
    draft_company: "草擬公司資料",
    inprogress_company: "處理中",
    cancel: "取消",
    shopping_cart: {
      heading: "摘要",
      item: {
        name: "項目名稱",
        price: "價格",
      },
      subtotal: "小結",
      buttons: {
        checkout: "結帳",
      },
    },
    sleeksign_nav: {
      description: "需要簽合約嗎？",
      link: "使用 SleekSign",
    },
    support: "支援",
  },
  $dashboard: {
    welcome_text_1: "{firstname}，歡迎您。這是您入門可以着手的事情。",
    welcome_text_2: "歡迎您，{firstname}。",
    get_started_text: "這是您入門可以着手的事情.",
    lets_go_text: "完成",
    //
    card_header_accounting: "會計支援",
    card_header_sign: "SleekSign",
    card_header_question: "存有疑問",
    card_header_company: "貴公司",
    card_header_documents: "公司文件",
    card_header_mailroom: "收發室",
    card_header_company_id: "公司 ID",
    fully_incorporated: "你可以在註冊完成後訪問此內容",
    tasks_and_alerts: "留意事項和警告",
    tasks_and_alerts_heading: "留意事項和警告",
    //
    tile_text_start: "建立一家新公司",
    tile_text_transfer: "將現有公司秘書或會計服務轉移到 Sleek",
    tile_text_sign: "在世界任何地方均能安全地簽署文件。費用全免！",
    card_text_sign: "我們的免費服務讓您在世界任何地方都能安全地簽署文件。",
    card_text_accounting: "隨時檢視可用的會計服務。",
    card_text_question: " 致電 +852 3594 4334 聯絡我們，或傳送電郵至",
    //
    card_field_label_registration: "註冊號碼",
    card_field_label_status: "公司現況",
    card_field_label_date: "公司成立日期",
    //
    card_button_get_started: "開始使用",
    card_button_quote: "取得報價",
    card_button_contact: "聯絡支援",
    //
    button_view_more: "檢視更多",
    button_view_all: "檢視全部",
    button_accept_invite: "接受邀請",
    //
    card_link_mail: "customer@sleek.hk",
    card_send_enquiry: "發送查詢",
    //
    text_snackbar_1:
      "您的「認識客戶」流程已完成！我們已完成審視相關文件和個人檔案詳細資訊",
    // Incorrect trans item
    // Should be: Welcome to Sleek Platform! We are currently reviewing the documents you have submitted with us as part of our KYC Process.
    // text_snackbar_2:
    //   "我們的 Sleek 團隊目前正在處理您取消向香港特別行政區繳納商業登記年費的請求。您的訂閱收發室、公司秘書 (1 名股東) 、10 萬開支會計計劃和 Xero 多種貨幣升級服務已經啟用。",
    //
    card_text_empty_mailbox: "您的收件匣是空的",
    //
    alert_message_title_invite: "邀請",
    you_are_invited_to:
      "您獲邀加入 <strong>{invitingCompanyName}</strong>，職位為 <strong>{userRole}</strong>",
    // perks
    perks_slider_heading: "獲得的合作夥伴的獨家優惠",
  },
  $login: {
    welcome_v1: "歡迎來到",
    welcome: "歡迎您的到來！",
    password_not_match_records: "電郵密碼不符",
    tagged_user: "該公司將被標記到您的 Sleek 帳戶",
    email_label: "電郵",
    password_label: "密碼",
    forgot_password: "忘記密碼？",
    login: "登入",
    create_account: "新建帳號",
    new_to_sleek: "Sleek 新用戶?",
    request_for_reset: "輸入您的帳戶電郵地址以請求重設密碼。",
    instructions_to_reset: "請檢查您的郵箱以獲取重置密碼的說明。",
    instructions_to_reset_generic:
      "如您的電郵地址已在我們系統中登記，我們會以電郵通知您相關程序。",
    invalid_email: "請提供有效的電郵地址。",
    incorrect_email_or_password: "錯誤的郵箱帳號或密碼。",
    submit: "提交",
    back: "返回",
    error: "錯誤",
    success: "成功",
    reset_password: "重設密碼",
    new_password: "新密碼",
    confirm_password: "確認密碼",
    password_length: "密碼長度必須至少為<strong>8</strong>個字元",
    password_uppercase: "密碼必須至少包含一個大寫字元（A-Z）",
    password_digit: "密碼必須至少包含 1 位數字（0-9）",
    password_special_char: "密碼必須至少包含 1 個特殊字元",
    passwords_do_not_match: "密碼不匹配。",
    reset_successfully: "您已成功重置密碼。",
    logged_in_as: "您已登入為",
    logout: "登出",
  },
  $incorporate: {
    stepper: {
      identity_verification: {
        verified: "已經完成驗證",
        complete_profile: {
          complete_your_profile: "完成您的個人檔案",
          complete_profile_button: "完成個人檔案",
          complete_profile_button_capital: "完成個人檔案",
          your_profile_is_completed: "您的個人檔案已經完成。",
          personal_information: "個人資料",
          identity_documents: "身份證明文件",
          residential_information: "居住資料",
          declaration: "聲明",
        },
        of_company_members: "公司成員的身份驗證",
        notification_email_has_been_sent:
          "已向需要採取進一步行動進行身份驗證的公司成員傳送通知電郵。",
        remind_all_capital: "提醒所有成員",
        send_email_reminder:
          "向所有公司成員傳送電郵提醒。一旦他們收到邀請電郵，即可點擊電郵的連結，在 Sleek 平台上註冊並輸入進行身份驗證的所需資料。",
        remind_all: "提醒所有成員",
        back_button: "返回",
        save_and_next_buttons: "儲存並繼續",
      },
    },
  },
  $invitations: {
    invitation_status: "新公司邀請現況",
    no_pending: "沒有待處理邀請",
    my_pending_invites: "我的待處理邀請",
    accept_invite: "接受邀請",
    login: "登入",
    email: "電郵",
    password: "密碼",
    next: "繼續",
    skip_this: "忽略這個",
    begin_verification: "開始驗證",
    to_be_director: "受邀擔任{company_name}董事",
    to_be_individual_shareholder: "受邀擔任{company_name}個人股東",
    to_be_corporate_shareholder: "受邀擔任{company_name}公司股東",
    invitation_description:
      "在我們為您建立帳戶之前，根據香港法律要求，您必須先提供經驗證的個人資訊。<br><br>請準備以下文件並選擇您的個人資料。",
    foreigner: "外國人",
    foreigner_tooltip:
      "外國人是指以下人士：<br /><br /><ul class='pl-3'><li>並未持有香港身份證（HKID）</li><li>並非香港公民（沒有香港護照)</li><li>並非香港居民</li></ul><br />上述內容適用於任何居住地點。",
    hkid_holder: "香港身份證持有人",
    hkid_holder_tooltip:
      "香港身份證持有人是指：<br /><br /><ul class='pl-3'><li>持有香港身份證（HKID）</li><li>並非香港公民（沒有香港護照)</li><li>有權在香港居住</li></ul><br /> 上述內容適用於任何居住地點。",
    hk_citizen: "香港公民",
    hk_citizen_tooltip:
      "香港公民是指以下人士：<br /><br /><ul class='pl-3'><li>持有香港身份證（HKID）</li><li>是香港公民（持有香港護照或在其香港身份證的出生日期下方標有***）</li><li>有權在香港居住</li></ul><br /> 上述內容適用於任何居住地點。",
    back: "返回",
    get_phone_camera_ready: "準備好手機和相機",
    redirect_to_onfido:
      "您將被重新導向至 Sleek 的合作夥伴 OnFido 以執行 e-「認識客戶」。在此過程中，您需要連接到系統 {0}。",
    redirect_to_onfido_once: "一次",
    redirect_to_onfido_twice: "兩次",
    connect_via_qr_sms_submit_id: "透過二維碼或短訊連接並提交{0}",
    id_is_WP_PR_SG: "zh_your {idtype} and selfie`",
    id_biopage: "護照的生物數據頁面",
    id_hkid: "香港身份證和自拍照片或影片",
    connect_via_qr_sms_submit_biodata:
      "透過二維碼或短訊連接並提交護照的生物數據頁面",
    start_verification: "開始驗證",
    process_submitting_kyc:
      "您正在提交{idtype}和自拍照。您將被要求說出一個代碼。請說英語。",
    idtype_hkid: "香港身份證",
    idtype_passport: "護照",
    almost_done: "即將完成",
    connect_one_more_time:
      "您需要<span class='font-weight-bold'>再次</span>連接系統。",
    personal_information: "個人資料",
    contact_details: "聯絡詳細資訊",
    phone_number: "電話號碼",
    required: "必填項目",
    consent_to_banks: "同意向授權銀行發佈個人資訊",
    allow_info_for_bank_account: "我允許我的資訊被發佈並作銀行開戶之用",
    residential_information: "居住資料",
    residential_address: "居住地址",
    addr_line_1: "地址列 1",
    addr_line_2: "地址列 2",
    addr_line_3: "地址列 3",
    city: "城市",
    state: "州",
    postal_code: "郵政編碼",
    district: "區",
    country: "國家",
    supporting_document: "補充文件",
    supporting_document_subtitle: "請確保上載的圖像清晰。",
    upload_proof_of_residence: "上載 3 個月內的居住證明",
    upload_proof_of_residence_tooltip:
      "可接受的文件包括水電費賬單、銀行月結單、稅務記錄或政府或機構簽發的其他文件。<br><br>相關文件不得超過三 (3) 個月。<br><br>Sleek 可以接受中文、英文、法文、德文、印尼文、馬來文、葡萄牙文、俄文、西班牙文和越南文的文件。<br><br>其他語言的文件必須由經認證的翻譯人員翻譯成英文。<br><br>許多客戶選擇與 <a href='https://www.wordsburg.com.sg/' target='_blank'>Wordsburg</a> 合作。<br><br>透過 <a href='mailto:info@wordsburg.com.sg'>info@wordsburg.com.sg</a> 與他們聯絡，並表明您是由 Sleek 推介的。",
    upload_proof_of_residence_description:
      "<p>1 份水電費賬單、銀行月結單或報稅表。</p><strong>格式：</strong>PDF、JPG、PNG。<strong>檔案大小上限：</strong>每個檔案 10MB。",
    add_files: "新增檔案",
    declaration: "聲明",
    are_you_pep: "您是否政治人物或與政治人物有關？",
    pep_description:
      "政治人物是指曾在{country}、{country}以外的國家或地區擔任任何重要公共職能的人士，或受國際機構委任相關職務。「相關」是指您是政治人物的父母、配偶、兄弟姐妹或子女，或是在社交或專業領域與政治人物密切相關的人士。",
    country_name: "香港特別行政區",
    radio_yes: "有",
    radio_no: "否",
    convicted_crime: "您曾否因涉及欺詐或不誠實的罪行而被定罪？",
    pep_agree_text:
      "我聲明以上資訊均真實無誤。我明白，如果發現我作出任何明知虛假，又或者是我不相信屬實的虛假陳述，抑或故意隱瞞重要事實，則可能會受起訴和刑事制裁。",
    declare_checkbox: "我聲明以上資訊均真實無誤。",
    submit: "提交",
    save_and_next: "儲存並繼續",
    save_and_review: "儲存並審閱",
  },
  $accounting: {
    plans: [],
    services: [],
    service_add_ons: {},
    service_options: {
      ANNUAL_FILLING_BOOKKEEPING: "會計計劃 - 年度簿記",
      ACCOUNTING_PAYROLL: "會計計劃 - 會計和工資單",
      ACCOUNTING_PREMIUM: "會計計劃 - 會計溢價",
    },
    checkout_accounting_plan_text_plain: "核算计划",
    pricing_suffix: "以下",
    packages: {
      packages: "計劃",
      accounting_options: "會計選項",
      para1_title: "選擇每月開支，我們將為您提供報價。",
      para1_body: "如果您的開支隨時間出現變化，相關金額將按季度作出調整。",
      para2_body:
        "根據您的每月開支取得以下估算報價。如有任何疑問，請聯絡我們，我們將在 3-5 個工作日內回覆。",
      tooltip1: "平均而言，您每月在業務所需的商品和服務上花費多少錢？",
      tooltip2:
        "在估算中包含所有薪酬或銷售成本（COGS）。如果您從業務收入中抽取了佣金，請不要將其包含在開支總額。",
      monthly_expenses1: "",
      monthly_expenses2: "",
      accounting_year_label: "財政年度",
      orless: "或以下",
      accounting_fees: "會計費用",
      payroll_support: "薪酬事務支援",
      multicurrency_support: "多種貨幣支援",
      multicurrency_tooltip:
        "多種貨幣支援將助您以一種以上貨幣完成的業務交易記錄帳目。",
      included_text1: "所包含服務",
      included_text2: "不論每月開支為何，您都將獲得以下服務：",
      whats_included_packages: [
        "設定和入門",
        "訂閱 Talenox 的薪酬事務支援",
        "每月記帳",
        "每月管理報告",
        "Xero 和數碼收據提交",
      ],
      plan_details: {
        estimated: "如果您還不知道估計的每月支出，你可以先選擇最低的選項。",
        compared_all: "比較計劃",
        total_average: "您平均每月的商務總支出是多少？",
        your_average_monthly: "您的平均月支出會影響服務報價",
        adjust_your_project:
          "調整您的預計月支出，以查看我們3種會計記帳服務的價格",
        all_our_plans: ` 我們所有的計劃都包括專用會計師、簿記、及強積金薪報表、SleekBooks 軟件、未審計的財務報表和智能收據提交系統`,
        compare_plan: "比較計劃",
        selected_estimate: "選擇你的估計平均每月開支",
        dedicated:
          "專用會計師、簿記、薪酬及強積金薪報表、SleekBooks 軟件、未審計的財務報表和智能收據提交系統",
        time_to_respond: "回應時間",
        management_accounts: "管理報告",
        payroll: "工資單",
        tax_structuring: "稅收結構/規劃/建議",
        review_with_sen: "與高級會計師審查",
        xero_subscription: "Xero 訂閱",
        xbrl_preparation: "",
        audit_tax_filing: "財務審計和報稅",
        gst_filling:
          "Annual GST filing (one time registration fee of {priceParam} added at checkout)",
        annual_gst_filing:
          "Annual GST filing (one time registration fee of {priceParam} added at checkout)",
        accounting_options: [],
        accounting_options_popup: [],
        sale_team_in_touch:
          "“沒問題！我們的銷售團隊將在您付款後 24 小時內與您聯繫，討論適合您業務的計劃。",
        faciliate_discussion: "為方便討論，請說明您估計的平均每月開支。",
      },
      whats_included_packages_with_accounting_software: [
        { name: "Payroll support" },
        { name: "Setup & onboarding" },
        { name: "Monthly bookkeeping" },
        { name: "Unaudited Financial Statements" },
        { name: "Monthly management report" },
        { name: "ECI & corporate tax return" },
        { name: "Accounting Software", hasDisclaimer: true },
        { name: "Tax support" },
        { name: "Digital Documents Submission" },
        { name: "Multi-currency support" },
      ],
      whats_included_sub_text: "所有層級均包含以下服務：",
      accounting_software_disclaimer_text:
        "在一般設定上，你已經擁有 SleekBooks 會計系統。您可以現在或者在系統實施及培訓時注明您想使用更高階的Xero會計系統。",
      accounting_suggest_plan_text_header: "選擇每月開支，我們將為您提供報價",
      accounting_suggest_plan_text_sub_header:
        "如果您的開支隨時間出現變化，相關金額將按季度作出調整。",
      monthly_expense_sub_text: "包括工資單",
      add_ons_text: "附加組件",
      contact_us_not_capital: "聯絡我們",
      per_financial_year_label: "每個財政年度",
      contact_me_later: "稍後與我聯絡",
      request_thankyou:
        "謝謝您！我們已知悉您的要求，我們的會計團隊將在 1 個工作日內與您聯絡。",
      backto_dashboard: "前往資訊主頁",
      accounting_package_none: {
        title: "每月開支超過{monthlyExpenses}？",
        subtitle: "請告知我們，我們將與您聯絡",
      },
      xero_subscription: {
        title: "Xero 系統訂閱",
        descriptionClaimer:
          "您可以通過 Sleek 成為 Xero 系統。我們作為Xero的伙伴會為您安裝系統及確保運行暢通。",
        descriptionNonClaimer:
          "Xero accounting software is included in your package and fully covered by Sleek",
        tooltip: {
          title:
            "不只是單一應付稅務及會計上的合規性，Xero還可以為您帶來更多功能：",
          value: ["創建您的銷售單", "連接第三方軟件", "隨時隨地存取即時報表"],
        },
      },
      xero_subscription_1_year: "Xero 系統訂閱 (一年)",
      inclusion: {
        monthly_bookkeeping: "每月記帳",
        monthly_management_report: "每月管理報告",
        digital_documents_submission: "電子單據存取",
        setup_onboarding: "設定及入門",
        payroll_support: "薪資管理",
        financial_statements: "未經審計財務報表",
        track_income_and_expenses: "追蹤收入與開支",
        multi_currency_support: "多種貨幣支持",
      },
      add_xero_subscription: "加 Xero 系統訂閱",
      xero_subscription_sub_title: "Xero -  1  年訂閱",
      audit_tax_filing: "財務審計和報稅",
      gst_filling_sub_title: "GST 年度合規",
      gst_one_time_reg_title: "一度 GST Registration",
      read_more_link_text: "什麼是 Xero?",
      accounting_software: "會計軟件",
      xero_subscription_optional: {
        unchecked:
          "在一般設定上，你已經擁有 SleekBooks 會計系統。您可以現在或者在系統實施及培訓時注明您想使用更高階的Xero會計系統。",
        checked: "你已選擇Xero為您的會計軟件。",
      },
      xero_subscription_included: "Xero系統訂閱已包含在您的會計計劃之中",
      no_plan_selected: "未選擇計劃",
    },
    files: {
      files: "檔案",
      accounting: "會計",
      upload: "上傳",
      upload_document: "上傳文件",
      upload_title: "上傳文件",
      upload_file: "上載檔案",
      download_file: "下載檔案",
      preview: "預覽",
      rename: "重新命名",
      delete: "刪除",
      cancel: "取消",
      audit: "審計",
      tax: "稅務",
      payroll: "薪酬事宜",
      bank_statements: "銀行月結單",
      management_reports: "管理報告",
      agreements: "合約",
      onboarding: "入門",
      accounting_no_access_text:
        "您沒有訂閱我們的會計服務計劃。如欲訂閱，請透過 <a href='mailto:customer@sleek.hk'>customer@sleek.hk</a> 聯絡我們進行諮詢",
      status_uploaded: "已上傳",
      status_uploading: "上傳...",
    },
    setup: {
      awaiting_email: "等待電郵驗證",
      email_sent1: "我們已傳送一封電郵至您的電郵地址。",
      email_sent2: "請點擊電郵內的連結以驗證此帳戶。",
      resend_email: "重新傳送電郵",
      refresh_page: "驗證後只需刷新此頁面。",
      success: "成功!",
    },
    accounting_plans: {
      title1: "会计计划",
      title2: "审核和付款",
      pay_now: "现在付款",
    },
  },
  $onboarding: {
    start_page_list_text: [
      "這是您上載的所有內容",
      "開始使用",
      "設置密碼來追踪你的文件",
    ],
    stepper: {
      step_1: "公司資訊",
      step_2: {
        option_1: "公司地址",
        option_2: "Address",
      },
      step_3: "董事及股東",
      step_4: "會計",
      step_business_account: "Business Account",
      step_5: "付款",
    },
    page_title: {
      header_support_number: "如需協助，請透過以下途徑聯絡我們：",
      speak_to_an_advisor: "與專員對話",
      page_1: "開始使用",
      page_2: "註冊公司地址",
      page_3: "邀請公司成員",
      page_4: "您的會計需要",
      page_business_account: "Business account",
      page_5: "審閱及付款",
      company_address_centered: "Company address",
    },
    card: {
      title: {
        name_check: "Company name checker",
        classify: "Classify your company",
        business: "Business Account",
        company_name: "公司名稱",
        business_activity: "業務性質",
        source: "資金來源",
        more: "關於您的更多資訊",
        registered_office_address: "註冊辦事處地址",
        directors: "董事",
        shareholders: "股東",
        company_details: "公司資料",
        services_required: "所需服務",
        buttons: {
          check: "CHECK",
          back: "返回",
          save_next: "儲存並繼續",
          save: "儲存",
          add: "新增",
          contact_us: "聯絡我們",
          continue_to_payment: "CONTINUE TO PAYMENT",
          apply: "套用",
          pay: "支付",
          payment_made: "I'VE Made my payment",
          pay_later: "I'll pay later",
          cancel: "取消",
          remove: "Remove",
          confirm: "Confirm",
          email_invoice_to_me: "EMAIL INVOICE TO ME",
          go_to_dashboard: "前往資訊主頁",
          proceed: "繼續",
          pay_now: "立即付款",
        },
      },
      info: {
        source: "您投入的資金是合規檢查的重要組成部分。",
        more: "這有助於我們為您提供更出色的服務",
        registered_office_address: {
          option_1: {
            p_1: "如果您沒有註冊公司地址，請使用 Sleek 的地址。",
            p_2: "我們將掃描您的郵件，每週將其上載到您的帳戶，並作出通知。",
          },
          option_2: {
            p_1: "它必須是實際的辦公地址而非郵政信箱。",
            p_2: (ctx) => {
              const link = ctx.named("link");
              const linkEnabled = ctx.named("link_enabled");
              const suffix = linkEnabled
                ? `<a target='_blank' href='${link}'>您符合所有標準</a>。`
                : "您符合所有標準。";
              return `請確保${suffix}`;
            },
          },
        },
        directors: "我們將向公司成員傳送電郵邀請以進行身份驗證。",
        shareholders: "我們將向公司成員傳送電郵邀請以進行身份驗證。",
        company_details: "請確保所提供的資料與公司註冊處所豋記的資料一致。",
        services_required:
          "如想把現有公司轉至Sleek管理，我們將與您現在的公司秘書聯絡以順利進行轉換。",
      },
      buttons: {
        check: "CHECK",
        back: "返回",
        save_next: "儲存並繼續",
        save: "儲存",
        add: "新增",
        contact_us: "聯絡我們",
        continue_to_payment: "CONTINUE TO PAYMENT",
        apply: "套用",
        pay: "支付",
        payment_made: "I'VE Made my payment",
        pay_later: "I'll pay later",
        cancel: "取消",
        remove: "Remove",
        confirm: "Confirm",
        email_invoice_to_me: "EMAIL INVOICE TO ME",
        go_to_dashboard: "前往資訊主頁",
        proceed: "繼續",
        pay_now: "立即付款",
      },
      links: {
        promo_code: "有優惠碼嗎？",
        classify: "此為快速指南。>",
        business_operation_2: "您符合所有標準。",
        change_payment: "Change payment method",
        discount: "折扣",
      },
      extras: {
        business: {
          beta: "BETA",
          free: "included for FREE",
        },
      },
      texts: {
        registered_office_address: {
          option_2: {
            p_1: "It has to be a physical office address, and cannot be a P.O. box address.",
            p_2: (ctx) => {
              const link = ctx.named("link");
              const linkEnabled = ctx.named("link_enabled");
              const suffix = linkEnabled
                ? `<a target='_blank' href='${link}'>you meet all the criteria</a>.`
                : "you meet all the criteria.";
              return `Please ensure that ${suffix}`;
            },
          },
        },
      },
    },
    fields: {
      placeholders: {
        company_name_first: "公司名稱 - 首選",
        company_name_second: "公司名稱 - 次選",
        company_name_third: "公司名稱 - 第三選擇",
        company_name_business: "商業名稱 - 如果與公司名稱不同",
        company_activity: "SSIC - Company Activity",
        secondary_ssic: "SSIC - Secondary Company Activity",
        primary_business_activity: "主要業務性質",
        secondary_business_activity: "次要業務性質",
        business_activity_description: "請描述您的主要業務性質",
        secondary_business_activity_description: "請描述您的次要業務性質",
        other_reason: "其他原因",
        specify_amount: "Please specify the amount",
        address_type: "地址類型",
        address_line_1: "地址列 1",
        address_line_2: "地址列 2",
        postal_code: "Postal Code",
        quarterly_average: "您的季度平均每月支出",
        describe_accounting_needs: "扼要說明您可能擁有的任何其他會計需求",
        promo_code: "優惠碼",
        select_card: "選擇銀行卡",
        name_on_card: "持有人名字",
        card_number: "信用卡號碼",
        cvc: "CVC",
        expiry: "到期日（MM/YY）",
        use_existing: "使用現有聯絡人",
        first_name: "名字",
        last_name: "姓氏",
        email: "電郵",
        type_of_shareholder: "股東類型",
        company_name: "公司名稱",
        country: "國家",
        business_registration_label: "請依據{registration_label}的名稱",
      },
      select_option: {
        address_type_commercial: "公司辦公室",
        address_type_home: "居家辦公室",
        add_new_card: "新增銀行卡",
      },
      form_label: {
        country: "國家",
        toggle_same_address:
          "Business operation take place at the same address",
        agree_terms: "I agree with the terms & conditions",
        with_accounting: "With accounting plan. Customize in the next step.",
        with_security_deposit:
          "With S$2000 security deposit. Will be refunded at the end of the term.",
      },
      error_message: {
        company_name: "公司名稱為必填項目",
        company_name_second_required: "公司名稱 - 次選為必填項目",
        company_name_third_required: "公司名稱 - 第三選擇為必填項目",
        required: "必填欄目。",
        business_activity_description: "描述必須至少有 100 個或更多字元",
        select_country: "請至少選擇 1 項。",
        select_one: "請至少選擇 1 項。.",
        please_select: "請選擇。",
      },
      success_message: {
        company_name: "Available (Subject to final confirmation by ACRA)",
      },
      misc: {
        others_specify: "其他，請指明",
      },
    },
    content_title: {
      registered_address: "公司地址",
      business_operation: "公司地址",
      nominee_director: "Duration for Nominee Director",
      directors: "董事",
      shareholders: "股東",
    },
    content_paragraph: {
      payment: {
        success: {
          login: "登入成功",
          thank_you: "謝謝您, {name}",
          processed: "付款已處理。",
          next_step: "下一步驟 - 第 2 階段",
          allocate: "分配公司股份。此為",
          quick_guide: "快速指南",
          compliance:
            "合規事項：為所有公司成員單獨完成身份驗證（已向所有人傳送電郵邀請）。",
          prepare_incorp:
            "完成身份驗證後，我們將在第 3 階段準備公司註冊文件供您簽署。",
          minutes: "10 分鐘",
          transfer_next_step: "Sleek 收到您的付款後，您將能夠進行下一步。",
        },
        error: {
          login: "錯誤的郵箱帳號或密碼。",
        },
        summary: {
          mode_of_payment: {
            title: "付款方法",
            selection: {
              card: "信用卡／扣賬卡",
              bank: "銀行轉帳",
            },
          },
        },
      },
    },
    label_included: "包括 ",
  },
  $public_onboarding: {
    label_included: "包括 ",
    country: "",
    navigation: {
      steps: "第 {current_step} 步（共 {total_steps} 步）",
    },
    headers: {
      lets_get_down: "我們開始吧。",
      nice_to_meet_you: "很高興認識您，\n{name}!",
      company_director: "您是這家公司的董事嗎？",
      how_many_shareholders: "您將登記多少名股東？",
      mailroom_mandate: "",
      would_you_like_address:
        "Will your company have a physical location other than your home? | Will {company_name} have a physical location other than your home? | x",
      accounting_header_text: "",
      youre_doing_great_text: "很好, {user_name} 即將大功告成。",
      checkout_page_text: "您的定製註冊服務套裝",
      bank_transfer: {
        card_text: "使用銀行轉帳付款",
        card_sub_text:
          "使用這些銀行詳細信息通過網上銀行或銀行的手機應用程式進行付款。",
        bank_details:
          "確保在備註或註釋部分包含<strong>{invoice_number}</strong>。 這是為了幫助識別您的交易。",
        bank_transfer_header: "Sleek的銀行詳細信息",
        receipient_name: "收款人姓名",
        bank: "銀行",
        account_number: "帳戶號碼",
        code_label: "銀行國際代碼",
        amount_to_transfer: "轉賬金額",
        note: "注意：您的銀行轉帳可能需要 2 到 3 個工作日才能送達我們。",
        btn_payment: "我已付款",
        btn_pay_later: "我稍後付款",
        reference_comments: "参考资料 / 評論",
      },
    },
    sub_headers: {
      whats_your_name: "首先，您叫什麼名字？",
      whats_your_name_and_email: "首先，您的姓名和電子郵件地址是什麼？",
      what_company_name: "您希望註冊的公司名稱是什麼？",
      before_incorp_unique_company_name:
        "在成立香港公司之前，你需要確保擁有<strong>一個獨一無二的公司名稱。</strong>",
      always_skip_and_decide_later:
        "在此處檢查你的公司名稱是否可用。 你可以跳過此步驟，稍後再決定你的公司名稱",
      they_ensure_legal_compliant:
        "這能確保您的公司在法律上合乎當地法律規定，首先要任命至少一名法定股東和一名當地居住董事。",
      must_register_address: "",
      thinking_of_residential: "",
      mailroom_price_text: "",
      mailroom_too_description: "",
      accounting_sub_header_text: "",
      accounting_sub_header_text2: "",
      checkout_page_sub_text:
        "基於您告訴我們的情況，我們建議繼續使用以下服務：",
    },
    fields: {
      form_label: {
        your_name: "您的名字",
        company_name: "公司名稱",
        your_company_name: "公司名稱",
        your_email: "電郵",
        checkbox_label:
          "允许 Sleek 就新产品和更新保持联系。您可以随时取消订阅。",
      },
      placeholder: {
        company_name: "Unicorn & Rainbows",
      },
    },
    copy: {
      desired_company_names: "期望的公司名稱：",
      no_of_shareholders: "股東人數：",
      any_csh: "是否有法人股東？",
      secretary_label: "",
      this_role_text: "職責:",
      cs_role_description: [
        "委任/更換董事/公司秘書/核數師",
        "更新您的高級職員資料和更改註冊辦事處地址",
        "股息分派",
        "遞交週年申報表（含申報費）",
        "備存重要控制人登記冊",
        "備存公司的法定記錄",
        "準備股東週年大會文件",
      ],
      shareholder_role_description: {
        text_1: "香港註冊公司必須至少有一名股東。",
        text_2: "您也可以稍後添加更多股東。",
      },
      accounting_support_message:
        "選擇您預計的每月開支，我們會建議適合您業務的計劃。",
      satisfaction_guaranteed_text: "100% 滿意保證",
      satisfaction_guaranteed_subtext:
        "如您對我們的服務不滿意，我們將在 30 天內退還已經收取的費用。",
      satisfaction_guaranteed_subtext_with_sleek:
        "如您對Sleek的服務不滿意，我們將在 30 天內退還已經收取的費用。",
      what_to_expect_next_text: "下一步",
      what_to_expect_steps: [
        {
          message: "填寫您的公司資料",
          duration: "2 分鐘",
        },
        {
          message: "註冊公司地址",
          duration: "2 分鐘",
        },
        {
          message: "邀請公司成員並分配您公司的股份。",
          duration: "10 分鐘",
        },
        {
          message: "簽署並處理文件",
          duration: "2 日",
        },
      ],
    },
    buttons: {
      brainstorming: "關於名稱，我還在考慮中",
      skip_for_now_decide_later: "暫時略過，我稍後再決定。",
      name_availability: "檢查名稱可用性",
      save_for_later: "儲存",
      save_for_later_mobile: "節省",
      show_more: "查看全文",
      show_less: "查看更少",
      add_on_services: "附加服務",
      need_guidance: "需要支援",
    },
    toggle_buttons: {
      toggle_yes: "是",
      toggle_no: "否",
      has_csh: "我有一名法人股東",
      no_csh: "我沒有法人股東",
    },
    accordion: {
      company_secretary: {
        title: "公司秘書",
      },
      shareholders: {
        title: "股東",
      },
      considered_expense: {
        title: "哪些費用會被視為「開支」？",
        p_1: "企業中有幾種類型的開支。對它們進行分類的最常見方法是按營業與營業外以及固定與可變類型劃分。",
        p_2: "企業透過其正常業務營運產生的營運費用，例如：",
        operating_expenses: [
          "銷貨成本 (COGS) – 例如： 勞動力成本、材料成本等",
          "推廣、廣告及促銷",
          "薪資、福利及工資",
          "銷售、一般和管理 (SG&A) – 例如：銷售成本、交付成本、公司管理成本",
          "租金及保險",
          "折舊及攤銷",
        ],
        p_4: "與正常經營活動無關的營業外開支，例如：",
        non_operating_expenses: ["利息", "稅收", "減值費用"],
        p_5: "即使銷售或生產中的商業活動可能增加或減少，固定開支每月也不會變化並保持不變，例如：",
        fixed_expenses: [
          "租金",
          "工資、福利和工資（有時是固定的，有時可變動）",
        ],
        p_6: "視乎銷售或生產中的商業活動，每月不斷變化的可變開支，例如：",
        variable_expenses: [
          "交易費用",
          "佣金",
          "市場推廣和廣告（有時是固定的，有時可變動）",
        ],
      },
    },
    footnote: {
      company_name_availability: "* 公司名稱的可用性取決於監管機構的最終確認",
      terms_and_privacy_text:
        "註冊即表示您<a href='{terms_url}' target='_blank'>接受我們的使用條款</a>及<a href='{privacy_url}' target='_blank'>私隱政策</a>。",
    },
    duration_labels: {
      one_time: "一次性",
      per_year: "/ 年",
      calendar_year: "年",
      year: "年",
      per_financial_year: "／財政年度",
      financial_year: "財政年度",
      per_financial_year_no_space: "/財政年度",
      minutes: "分鐘",
      days: "日",
    },
    checkout_values: {
      currency_text: "港幣$",
      whats_included_text: "包含服務",
      whats_included_text_straight: "包含服務",
      checkout_button: "繼續結帳",
      checkout_button_short: "前往結帳",
      sub_header: "保存進度並稍後付款",
      save_package_button: "儲存套餐",
      edit_package_button: "編輯套裝",
      basic_services: [],
      addOn_services: [],
      corporate_secretary_subtext: {
        "corp-sec-1-shareholder": "1 股東",
        "corp-sec-2-shareholder": "2 名股東",
        "corp-sec-3-to-5-shareholder": "3 to 5 名股東",
        "corp-sec-6-to-9-shareholder": "6-9 名股東",
        "corp-sec-10-to-20-shareholder": "10 to 20 名股東",
        "corp-sec-21-to-30-shareholder": "21 to 30 名股東",
        "corp-sec-31-to-50-shareholder": "31 to 50 名股東",
      },
      corporate_shareholders_text: "公司股東",
      sub_accounting_adjust_text:
        "調整您的每月開支，我們會建議適合您業務的計劃",
      sub_accounting_adjust_text_2:
        "您的會計計劃將視乎每個財政年度的平均每月開支作出調整。</br>如果低於或高於所選閾值, 我們會將其記入帳戶, 或按相應比例向您開立發票。",
      show_more_accounting_included: [],
      show_more_accounting_add_ons_text: "",
      full_accounting_package_included_text: "",
      loading_text: "正在加載...",
      up_to: "每月達",
      monthly_expense: "港元的開支",
      more_than: "每月超過",
    },
    payment_page_values: {
      back_text: "返回",
      great_choice_text: "不錯的選擇！",
      lets_make_it_official_text: "讓我們正式確定",
      create_account_pay_text: "建立帳戶並付款",
      payment_details_text: "付款資料",
      payment_options: [],
      login_options: [],
      cardholders_name_text: "持卡人姓名",
      card_number_text: "銀行卡號碼",
      expiration_text: "到期日",
      cvc_text: "",
      your_contact_details_text: "您的聯絡詳細資訊",
      first_name_text: "名字",
      last_name_text: "姓氏",
      email_text: "電郵",
      country_code_text: "國家代碼",
      phone_text: "電話",
      all_fields_required_text: "*所有欄目必須填寫",
      new_user: "新用戶",
      existing_user: "現有用戶",
      allow_sleek_to_stay_in_touch_text:
        "允許 Sleek 就新產品和推廣更新與您聯絡。您可以隨時取消訂閱。",
      by_signing_up_text:
        "註冊即表示您同意我們<a href='{terms_url}' target='_blank'>的條款及細</a>則以及<a href='{privacy_url}' target='_blank'>私隱政策</a>。",
      trusted_by:
        "<p>受全球 <span><strong>{number_of_companies}</strong></span> 家企業信賴</p>",
      reviews_number: "{number_of_reviews}個谷歌評論",
    },
    images: {
      loader: "TC Loading.gif",
    },
    cart_summary_services: [],
    total: "合計",
    cart_summary: "購物車摘要",
    cart_summary_accounting: {
      accounting_annual_filling: "年度簿記 - 最多 {price} 個月的費用",
      accounting_payroll: "會計和工資單 - 最多 {price} 個月的費用",
      accounting_premium: "會計溢價 - 最多 {price} 個月的費用",
      above_value: "會計計劃 - 多於 {price} 個月的費用",
    },
    free: "免費",
    incorporation_assistance: "註冊協助費",
    company_registry_fee: "公司註冊申請費 (政府費用)",
    accounting_none_selected_text: "每月超過 {moneyValue} 的開支",
    pending_quotation: "等待引述",
    add_voucher: "新增優惠券代碼",
    payment_completion_values: {
      thank_you_text: "謝謝您!",
      after_payment_recieved:
        "Sleek 收到您的付款後，您才能夠繼續執行後續步驟。",
      title_text: "",
      after_payment_steps: [],
      complete_button_text: "完成公司設置",
    },
    save_for_later_page: {
      back_text: "返回",
      have_to_run_text: "需要離開？",
      drop_your_contact_text:
        "留下您的聯繫方式，我們會通過電子郵件向您發送一個鏈接，讓您從上次中斷的地方繼續。",
      see_you_soon_text: "再見！",
      first_name_text: "名字",
      last_name_text: "姓氏",
      email_text: "電郵",
      country_code_text: "國家代碼",
      phone_optional_text: "電話 (可選輸入)",
      phone_text: "電話",
      save_progress_btn: "儲存以供隨後使用",
      send_quote_btn: "發送報價",
      return_to_homepage_btn: "返回至主頁",
      have_questions_text: "有問題嗎？ 給我們打電話",
      first_name_required: "請提供您的名字",
      last_name_required: "請提供您的姓氏",
      email_required: "電郵為必填項目",
      email_invalid: "請提供一個有效的電郵地址",
      phone_required: "請提供您的電話號碼",
      phone_invalid: "請輸入正確電話號碼",
    },
    need_guidance_page: {
      first_name_text: "名字",
      last_name_text: "姓氏",
      email_text: "電郵",
      country_code_text: "國家代碼",
      phone_optional_text: "電話",
      phone_text: "電話",
      button_submit: "聯絡我們",
      button_back: "返回",
      card_text: "您的 Sleek 團隊隨時為您提供支援！",
      card_sub_text: "分享您的聯絡方式，我們將與您聯繫，協助您繼續上次的流程。",
      card_sub_text_2: "再見！",
      completed_main_text: "感謝您聯繫！",
      completed_sub_text_1: "我們的顧問將在 1 個工作天內與您聯繫。",
      completed_sub_text_2: "等不及了？致電話給我們！",
      completed_sub_text_3: "您可以退出此頁面或返回到上次離開的位置。",
      banner_main_text: "我們在此為您提供協助！",
      banner_sub_text: "分享您的進度並獲得我們團隊的幫助",
      banner_action_mobile: "開始進行吧",
    },
    dollar_value: {
      your_sleek_package_text: "您的 Sleek 計劃",
      dollar_value_list: [],
      total: "總共",
    },
    audit_plans: {
      "15_000_audit_plan": "審計計劃 - 每月高達 HK$15,000",
      "50_000_audit_plan": "審計計劃 - 每月高達 HK$50,000",
      "100_000_audit_plan": "審計計劃 - 每月高達 HK$100,000",
      "200_000_audit_plan": "審計計劃 - 每月高達 HK$200,000",
      "400_000_audit_plan": "審計計劃 - 每月高達 HK$400,000",
    },
    accounting: {
      total_average_monthly_business_expenditure:
        "您平均每月的商務總支出是多少？",
      accounting_title_sleek_package: "會計",
      xero_subscription_basis: "/財政年度",
      select_average_monthly: "選擇平均月支出",
    },
    audit_and_tax: {
      header_text_1: "需要在審計和稅務申報方面協助嗎？",
      subheader_text_1:
        "Sleek頂尖註冊會計師提供100％線上審計和報稅服務，盡享輕鬆、無憂稅季體驗！",
      subheader_text_2:
        "根據香港特別行政區法例，除了不活動公司外，所有香港公司均須進行財務報表的審計",
      main_header_text: "您平均每月的商務總支出是多少？",
      main_subheader_text:
        "「每月開支」是指營運公司的總花費，包括薪資、租金、商品/服務成本和營運成本等",
      select_business_expense: "選擇平均每月業務支出",
      main_dropdown_subtext: "項目費用將取決於您每月開支",
      whats_included_text: "Sleek審計及稅務項目包括：",
      selected_monthly_expense_text: "已選擇每月開支",
      plain_whats_included_text: "包含服務",
      audit_plans_list: [],
      whats_included_list: [],
      checkout_title_ext: "(港{audit_plan_value}元的每月開支)",
      audit_and_tax_plans: {
        "15_000_audit_plan": "審計和稅務 (港15,000元的每月開支)",
        "50_000_audit_plan": "審計和稅務 (港50,000元的每月開支)",
        "100_000_audit_plan": "審計和稅務 (港100,000元的每月開支)",
        "200_000_audit_plan": "審計和稅務 (港200,000元的每月開支)",
        "400_000_audit_plan": "審計和稅務 (港400,000元的每月開支)",
        "700_000_audit_plan": "審計和稅務 (港700,000元的每月開支)",
      },
    },
    send_quote: {
      button: "發送報價單",
      span: "需要更多時間處理？",
      cardText: "需要更多時間處理？",
      cardSubText: "如果您需要更多時間考慮，完全沒問題！",
      cardSubText2:
        "<p>留下您的聯絡方式後，系統會自動發送一個鏈接到您的郵箱，讓你隨時繼續填充資料。</p>下次見！",
    },
    remediation: {
      card_title2: "Accounting Remediation",
      card_description2:
        "Up to <strong>100 transactions</strong> for each past financial year",
    },
  },
  $shareholder: {
    services: [],
    default_option: "您有幾位股東",
    number_of_shareholder_determine: "股東人數將決定計劃的成本",
    number_of_shareholder_determine_content:
      "香港註冊公司必須至少有一名股東。您也可以在以後才增設更多的股東。",
    what_include: "公司秘書計劃包括以下內容：",
    what_include_content: [
      "提供一名公司秘書",
      "提供一名指定代表人",
      "任命/更改董事/公司秘書/審計師",
      "更改負責人資料",
      "更改註冊辦公地址",
      "分派股息",
      "提交年度申報（已包括申報費用）",
      "維護重要控制人登記",
      "維護公司的法定記錄",
      "準備年度股東大會（AGM）文件",
      "集中管理所有法定記錄和合規文件，可於線上隨時查閱",
    ],
    chose_your_secretary_plan: "請選擇您的公司秘書計劃",
    sub_title_2:
      "我們於每項成立公司計劃中都包含公司秘書服務，以滿足香港的合規要求",
    standard: {
      title: "標準",
        description: "適合需要快速啟動的初創企業。",
    },
    premium: {
      title: "高級計劃",
      description: "提供靈活選擇，滿足您不同階段的業務需求。",
    },
    financial: "/年",
    choose_a_plan: "請選擇一個計劃",
    included_standard_services: [
      "出任公司秘書及指定代表",
      "交付周年申報表 (包括登記費用)",
      "處理公司資料變更，包括董事資料和註冊辦公地址",
      "向稅務局 (IRD) 申報更改營業名稱或業務性質",
      "分行申請（不包括 HK$80 政府費用）",
    ],
    include_premium_services: [
      "向公司註冊處申報更改公司名稱（不包括 HK$295 政府費用）",
      "股份配發",
      "股份轉讓",
      "更換董事 (委任及辭任)",
    ],
    premium_include: "所有標準計劃內容以及",
    standard_include: "所有公司秘書計劃包括以下內容",
    what_included: "公司秘書計劃包括",
    tooltip: `<ul>
        <li>在香港註冊公司需要至少一名股東。</li>
        <li>公司秘書服務按股東人數收費。</li>
        <li>您日後亦可以隨時增加股東人數。</li>
      </ul>`,
    how_many_shareholder_you_have: "您有幾位股東？",
    select_shareholder: {
      title: "Select your number of shareholders",
      sub_title:
        "The cost of your plan is based on number of shareholders. You may add more shareholders at a later stage.",
    },
    no_thanks_btn: "No, thanks",
  },
};

export default messages;
